import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useTitleV2 } from 'src/hooks/use-title-v2';
import { TranslationKey } from 'src/types/i18next';

export const MainRouteV2 = ({
  title,
  component,
}: {
  title: TranslationKey;
  component: ReactNode;
}) => {
  const { t } = useTranslation();
  useTitleV2(t(title));

  return component;
};

